export const PASSWORD_RESET_STATUS = {
  SUCCESS: 'SUCCESS',
  INVALID_TOKEN: 'INVALID_TOKEN',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_FAILED: 'AUTH_FAILED',
  ERROR: 'ERROR'
};